<template>
	<div :class="classes" @click="onClick">
		<div :class="vdivClasses"></div>
		<div class="text" v-tooltip="text">
			<slot name="text">{{ text }}</slot>
		</div>
	</div>
</template>

<script>

export default {
	name: "NavSidebarItem",
	emits: [ "click", ],
	props: {
		class: {
			type: String,
			default: "",
		},
		text: {
			type: String,
			default: "",
		},
		isSelected: {
			type: Boolean,
			default: false,
		},
		showGuide: {
			type: Boolean,
			default: true,
		},
	},
	computed: {
		classes() {
			return {
				"nav-sidebar-item": true,
				"nav-sidebar-item--selected": this.isSelected,
				"text-default": true,
				[ this.class ]: !!this.class,
			};
		},
		vdivClasses() {
			return {
				guide: true,
				"guide--visible": this.showGuide,
			};
		},
	},
	methods: {
		onClick( e ) {
			e.stopPropagation();
			this.$emit( "click" );
		},
	},
};
</script>

<style lang="scss" scoped>
$navSidebarItemColor: $color1-500;
$navSidebarItemBackgroundColor: $mono-000;
$guideColor: $color1-100;
// selected
$navSidebarItemSelectedColor: $color2-600;
$navSidebarItemSelectedBackgroundColor: $color2-100;
// hover
$navSidebarItemHoverColor: $color1-600;
$navSidebarItemHoverBackgroundColor: $color1-100;

.nav-sidebar-item {
	display: flex;
	justify-content: flex-start;
	gap: 1rem;
}

.nav-sidebar-item .guide {
	visibility: hidden;
	padding-left: 1.2rem;
	border-right: 0.0625rem solid $guideColor;
}

.nav-sidebar-item .guide--visible {
	visibility: visible;
}

.nav-sidebar-item .text {
	color: $navSidebarItemColor;
	background-color: $navSidebarItemBackgroundColor;
	border-radius: 0.5rem;
	margin: 0.2rem 0;
	padding: 0.4rem;
	cursor: pointer;

	text-align: left;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	font-style: normal;
	font-weight: 600;

	width: 100%;
}

.nav-sidebar-item:not(.nav-sidebar-item--selected):hover .text {
	color: $navSidebarItemHoverColor;
	background-color: $navSidebarItemHoverBackgroundColor;
}

.nav-sidebar-item.nav-sidebar-item--selected .text {
	color: $navSidebarItemSelectedColor;
	background-color: $navSidebarItemSelectedBackgroundColor;
}
</style>
